






import {Vue, Component} from 'vue-property-decorator';

@Component({
    name: 'NotFoundView',
})
export default class NotFoundView extends Vue {

}
